import React, { useState, useEffect, useCallback } from "react";
import { Select, Row, Col, Form, Icon, Spin, DatePicker, Input, InputNumber, Button, Radio, Switch, message } from "antd";
import { BoldOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useHistory } from "react-router-dom"

import "./FormRegistro.scss";
import { Label } from "react-bootstrap";
import { Redirect } from 'react-router';
moment.locale('es');
export default function FormRegistroCasillas(props) {
//console.log("PROPS REGISTRO adju", props);
//console.log("PROPS REGISTRO ya fech ",props.handleSubmit);
var tiempoMensaje = 5;
    let idMedida=false;

    const { getFieldDecorator } = props.form;
    
    const dateFormat = "DD-MM-YYYY";
    const timeFormat = "HH:mm";

    const [rangeDates, setRangeDates] = useState({
        minInicio: moment().startOf('day'),
        minFin: moment().startOf('day')
    });

    const [redirect, setRedirect] = useState({
        redirecting: false,
        url: "/reportes",
        idTipoDocumentacion: props.idTipoDocumentacion
    });

    const [verificacion, setVerificacion] = useState({
        numero:props.numVerificacion});

        const [enabledRangeDate, setEnabledRangeDate] = useState({
            fechaInicio: false,
            fechaFin: false,
        });
            const [disableSwitch, setDisableSwitch] = useState(props.opcion===3 ?true: false);
            const [tipoCaptura, setTipoCaptura] = useState(props.activa);
            const [activa, setActiva] = useState(props.activa);
            
                                       
        const onSwitchChange = (c, e) => {
            //console.log(c,"SWITCH c")
           //console.log(e,"SWITCH tc")
           //console.log(activa,"SWITCH activa")
         setActiva(c);  
         //console.log(activa,"SWITCH activa1")
          };

          const [fechaVerificacion, setFechaVerificacion] = useState(props.fecha !==null && 
            props.fecha !== undefined && props.fecha !=="" ? props.fecha:moment().format('DD-MM-YYYY'));
          //  //console.log("PROPS FECHA1",props.fecha )
        ////console.log("PROPS FECHA",fechaVerificacion )
          //   let history = useHistory()
        
          const handleCambiaVerificacion = (e) => {
           //console.log('Received cambios of form: ', e.target.value);
            props.handleCambio( e.target.value);
                
               
      
        };

        const renderRedirectRegresar = () => {
            if (redirect.redirecting) {
                return <Redirect
                    to={{
                        pathname: redirect.url,
                        state: {
                            idTipoDocumentacion: redirect.idTipoDocumentacion
                        }
                    }}
                />
            }
        }

        const handleGuardaVerificacion = (e) => {
        e.preventDefault();
        let valida=false;
        let reg=0;
        let value;
        props.form.validateFieldsAndScroll((err, values) => {
            //console.log("Activa1", e)
            if (!err) {
               valida=true
                value=values
             
            }
        });

        props.data.map((val) => {
            //console.log("v1", val, "valu1",value)
            if(val.tipoCasilla===value.tipoCasilla )
            reg=reg+1
            })
   //console.log("v6", reg)
        if( reg ===1){
        message.error("Esta casilla ya fue registrada.", tiempoMensaje);
                return false;} 
                else if ( reg ===0 && valida===true) {
                    //console.log("entro en else")
                    activa===true? 
           value.verificacionActiva=1:
           value.verificacionActiva=0;
           value.idMedida=props.idMedida
            
           return  props.handleSubmit(value);
           
           //setFechaVerificacion(values.fechaVerificacion)
           ////console.log('Received values of form: ', values);
        }
        
    };

    const handleRangeNumber = (rule, value, callback) => {
        if (value && (value > rule.max || value < rule.min)) {
            callback(rule.message)
        }
        callback()
    }

    return (
        <div>
             {renderRedirectRegresar()}
            
            <div>
                <Form onSubmit={handleGuardaVerificacion} layout="vertical">
                    <Row>
                        <Col span={23} >
                        <label className="texto-18-adjudicacion-b">Casillas seleccionadas</label>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                 
                        <Col span={6}>
                            <Col span={22}>
            
                                    <label className="rojo-adjudicacion">* </label><label className="texto-16-seguimiento">Tipo de casilla</label>
                                
                                
                            </Col>
                        </Col>
                        <Col span={4}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-seguimiento">Cantidad de casillas</label>
                           </Col>
                        </Col>
                        <Col span={8}>
                            <Col span={22}>
                                <label className="texto-16-seguimiento">Comentario</label>
                           </Col>
                        </Col>
                    </Row>
                    <Row>
                    <Col span={6}>
                            <Col span={22}>
                                <Form.Item name="tipoCasilla" hasFeedback>
                                    {getFieldDecorator('tipoCasilla', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione un tipo de casillas.',
                                            }
                                        ],
                                    })(
                                        <Select
                                            placeholder="Seleccione opción"
                                        >
                                            {props.optionsTipo.map((value, index) => {
                                                let splited = value.split("-")
                                                let nom
                                                //console.log("val0", splited[0],"val1", splited[1],"val2")
                                                splited[2]?nom=(splited[1]+"-"+splited[2]):nom=splited[1]
                                           
                                                 
                                                   return <Select.Option key={value}>{nom}</Select.Option>
                                                    
                                            })}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={4}>
                            <Col span={20}>
                                
                              
                                    <Form.Item name="cantidad" hasFeedback>
                                        {getFieldDecorator('cantidad', {
                                            rules: [
                                                {
                                                    type: 'integer',
                                                    message: 'Cantidad no válida.',
                                                },
                                                {
                                                    required: true,
                                                    message: 'Ingrese la cantidad de casillas en las que se aplicó la verificación.',
                                                },
                                                {
                                                    validator: handleRangeNumber,
                                                    message: 'Canitdad fuera del rango permitido.',
                                                    min: 1,
                                                    max: 999
                                                }
                                            ],
                                        })(
                                            <InputNumber
                                            placeholder="Ingrese un número"
                                                style={{ width: '100%' }}
                                                min={1}
                                                max={999}
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                               
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                
                            </Col>
                     
                            <Col span={9}>
                            <Col span={22}>
                                <Form.Item name="comentarios">
                                    {getFieldDecorator('comentarios', {})(
                                        <Input.TextArea
                                            placeholder="Ingrese los comentarios"
                                            rows={2}
                                            autoSize={{ minRows: 2, maxRows: 2 }}
                                            allowClear={true}
                                            maxLength={1500}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={4} >
                            <Col>
                                <Form.Item >
                                    <Button className="agregar" type="primary" htmlType="submit" disabled={!props.enableCaptura}>
                                        <PlusOutlined />Agregar
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Col>
                       
                    </Row>
                </Form>
            </div>
        </div>
    )
}